import { QuestionModel } from "../models/QuestionModel";
import { QuestionType } from "../models/enums/QuestionType";

export function useAriaLabelledByForQuestionOpenEndChoiceBox(question: QuestionModel) {
    switch (question.type) {
        case QuestionType.RadioButton:
        case QuestionType.CheckBox:
        case QuestionType.DrillDown:
        case QuestionType.DropDownList:
        case QuestionType.TextAnswer:
        case QuestionType.EmailAddressAnswer:
        case QuestionType.NumericAnswer:
        case QuestionType.RespondentPhone:
        case QuestionType.OpenEndAnswer:
        // Grid question row/column too have openend inside cell
        // eslint-disable-next-line no-fallthrough
        case QuestionType.ChoiceGrid:
        case QuestionType.ImageChoiceGrid:
        case QuestionType.RunningTotal:
        case QuestionType.StarRatingGrid:
        case QuestionType.NetPromoter:
            return true;
        default:
            return false;
    }
}

export function useAriaLabelledByForInputFieldQuestion(question: QuestionModel) {
    const questionType = question.parent ? question.parent.type : question.type;

    switch (questionType) {
        case QuestionType.TextAnswer:
        case QuestionType.EmailAddressAnswer:
        case QuestionType.NumericAnswer:
        case QuestionType.RespondentEmail:
        case QuestionType.RespondentPhone:
        case QuestionType.OpenEndAnswer:
            return true;
        default:
            return false;
    }
}

export function useAriaLabelByForGridRenderedInputFieldQuestion(question: QuestionModel) {
    const questionType = question.parent ? question.parent.type : question.type;

    switch (questionType) {
        case QuestionType.RunningTotal:
            return false;
        default:
            return true;
    }
}

export function isFieldsetGroupingQuestion(question: QuestionModel) {
    switch (question.type) {
        case QuestionType.CheckBox:
        case QuestionType.RadioButton:
        case QuestionType.HybridGrid:
        case QuestionType.DrillDown:
        case QuestionType.NetPromoter:
            return true;
        default:
            return false;
    }
}

export function getAriaLabelledByFromId(question: QuestionModel, nameOrElementId: string) {
    const questionType = question.parent ? question.parent.type : question.type;
    switch (questionType) {
        case QuestionType.RadioButton:
        case QuestionType.CheckBox:
        case QuestionType.TextAnswer:
        case QuestionType.EmailAddressAnswer:
        case QuestionType.NumericAnswer:
        case QuestionType.RespondentEmail:
        case QuestionType.RespondentPhone:
        case QuestionType.OpenEndAnswer:
        case QuestionType.NetPromoter:
            return `${nameOrElementId}_LABEL`;
        case QuestionType.ChoiceGrid:
        case QuestionType.ImageChoiceGrid:
        case QuestionType.RunningTotal:
        case QuestionType.StarRatingGrid:
            return `${nameOrElementId}_CELL_LABEL`;
        case QuestionType.DrillDown:
        case QuestionType.DropDownList:
            return nameOrElementId;
        default:
            return "";
    }
}

export function getRoleForQuestion(question: QuestionModel) {
    switch (question.type) {
        case QuestionType.RadioButton:
        case QuestionType.CheckBox:
            return undefined;
        // For below question types normal a text box is display but choices can also be displayed
        // and because it doesn't have any grouping i.e. radiogroup is used
        case QuestionType.EmailAddressAnswer:
        case QuestionType.TextAnswer:
        case QuestionType.NumericAnswer:
        case QuestionType.OpenEndAnswer:
            return "radiogroup";
        default:
            return "group";
    }
}
